import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import commonReducer from './common/commonSlice';
import rdsReducer from './rds/rdsSlice';
import scheduleReducer from './schedule/scheduleSlice';
import winReducer from './win/winSlice';
import derivReducer from './deriv/derivSlice';
import trackReducer from './track/trackSlice';

export const store = configureStore({
  reducer: {
    common: commonReducer,
    rds: rdsReducer,
    schedule: scheduleReducer,
    win: winReducer,
    deriv: derivReducer,
    track: trackReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
